<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AJZJLX/tc-custom/9781452131061.jpg?1708749050047" alt="This image is the cover for the book Fallen Kingdom"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fallen Kingdom
      </h1>
      <p class="bookDescription body article font2">
        <b>The long-awaited final book in the trilogy that’s a “perfect</b><b> blend of historical fiction, fantasy, and steampunk” from the author of <i>The Vanishing Throne</i></b><b>(<i>VOYA</i>).</b><br/>  <br/> Aileana Kameron, resurrected by ancient fae magic, returns to the world she once knew with no memory of her past and with dangerous powers she struggles to control. Desperate to break the curse that pits two factions of the fae against each other in a struggle that will decide the fate of the human and fae worlds, her only hope is hidden in an ancient book guarded by the legendary Morrigan, a faery of immense power and cruelty. To save the world and the people she loves, Aileana must learn to harness her dark new powers even as they are slowly destroying her.<br/>  <br/> Packed with immersive detail, action, romance, and fae lore, <i>The Fallen Kingdom</i> brings the Falconer’s story to an epic and unforgettable conclusion.<br/>  <br/><b>Praise for the Falconer Trilogy</b><br/>  <br/> “A riveting world, a fierce heroine, and electrifying action.” —Sarah J. Maas, #1 <i>New York Times</i>–bestselling author<br/>  <br/> “Forget Bella, banish Katniss and Expelliarmus Hermione—there is a new breed of ass-kicker intown . . . Elizabeth May’s debut is a wicked cocktail of Jane Austen and the Grimms’ fairy tales.” —<i>SciFiNow</i><br/>  <br/> “Combines vivid world-building with action-packed fight sequences.” —<i>School Library Journal</i><br/>  <br/> “May deftly navigates Victorian romance, steampunkery, and now, dystopia. Surprising, well told.” —<i>Booklist</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elizabeth May
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?57f98ce0